// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2I5F6","results":"Table_results__tWd-x"};